(function () {
  if (window.KinujoQuickAdd) return;

  var modalEl = null;
  var els = {};
  var state = {
    mode: 'single', // 'single' (real Shopify variants) or 'group' (separate products standing in for variants)
    product: null,
    selectedOptions: [],
    variant: null,
    groupItems: [],
    groupIndex: 0
  };

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return '¥' + amount.toLocaleString('ja-JP');
  }

  function buildModal() {
    var wrap = document.createElement('div');
    wrap.id = 'KinujoQuickAdd';
    wrap.className = 'kinujo-quick-add';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="kinujo-quick-add__overlay" data-quick-add-close></div>' +
      '<div class="kinujo-quick-add__card" role="dialog" aria-modal="true">' +
      '<button type="button" class="kinujo-quick-add__close" data-quick-add-close aria-label="閉じる">&times;</button>' +
      '<div data-quick-add-content></div>' +
      '</div>';
    document.body.appendChild(wrap);

    wrap.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !wrap.hidden) close();
    });

    modalEl = wrap;
    els.content = wrap.querySelector('[data-quick-add-content]');
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    if (window.theme && theme.a11y && typeof theme.a11y.lockMobileScrolling === 'function') {
      if (lock) {
        theme.a11y.lockMobileScrolling('.kinujo-quick-add');
      } else {
        theme.a11y.unlockMobileScrolling('.kinujo-quick-add');
      }
    }
  }

  function close() {
    if (!modalEl || modalEl.hidden) return;
    modalEl.hidden = true;
    lockScroll(false);
  }

  function findVariant(product, selectedOptions) {
    return (
      product.variants.filter(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selectedOptions[index];
        });
      })[0] || null
    );
  }

  function renderShell(imageUrl, title, optionsHtml) {
    els.content.innerHTML =
      '<div class="kinujo-quick-add__image"><img src="' + imageUrl + '" alt="' + title + '"></div>' +
      '<h3 class="kinujo-quick-add__title" data-quick-add-title>' + title + '</h3>' +
      '<p class="kinujo-quick-add__price" data-quick-add-price></p>' +
      optionsHtml +
      '<div class="kinujo-quick-add__qty-row">' +
      '<span class="kinujo-quick-add__qty-label">数量</span>' +
      '<input type="number" class="kinujo-quick-add__qty" min="1" value="1" data-quick-add-qty>' +
      '</div>' +
      '<button type="button" class="kinujo-quick-add__submit" data-quick-add-submit>カートに追加</button>' +
      '<p class="kinujo-quick-add__note" data-quick-add-note hidden></p>';

    els.title = els.content.querySelector('[data-quick-add-title]');
    els.price = els.content.querySelector('[data-quick-add-price]');
    els.submit = els.content.querySelector('[data-quick-add-submit]');
    els.note = els.content.querySelector('[data-quick-add-note]');
    els.qty = els.content.querySelector('[data-quick-add-qty]');
    els.image = els.content.querySelector('.kinujo-quick-add__image img');

    els.submit.addEventListener('click', submit);
  }

  function renderProduct(product) {
    state.mode = 'single';
    state.product = product;
    state.selectedOptions = product.variants[0].options.slice();
    state.variant = findVariant(product, state.selectedOptions) || product.variants[0];

    var optionsHtml = product.options
      .map(function (option, index) {
        // Shopify's /products/{handle}.js has returned this as either a
        // plain name string or a { name, position, values } object
        // depending on API version — handle both instead of assuming one.
        var name = typeof option === 'string' ? option : option.name;
        var values = [];
        product.variants.forEach(function (variant) {
          var value = variant.options[index];
          if (values.indexOf(value) === -1) values.push(value);
        });
        var selectOptions = values
          .map(function (value) {
            return '<option value="' + value + '">' + value + '</option>';
          })
          .join('');
        return (
          '<div class="kinujo-quick-add__option">' +
          '<span class="kinujo-quick-add__option-label">' + name + '</span>' +
          '<select class="kinujo-quick-add__option-select" data-option-index="' + index + '">' +
          selectOptions +
          '</select>' +
          '</div>'
        );
      })
      .join('');

    var imageUrl = state.variant.featured_image ? state.variant.featured_image.src : product.featured_image;
    renderShell(imageUrl, product.title, optionsHtml);

    els.content.querySelectorAll('.kinujo-quick-add__option-select').forEach(function (select, index) {
      select.value = state.selectedOptions[index];
      select.addEventListener('change', function () {
        state.selectedOptions[index] = select.value;
        state.variant = findVariant(product, state.selectedOptions);
        updateForSelection();
      });
    });

    updateForSelection();
  }

  function renderGroup(items, label) {
    state.mode = 'group';
    state.groupItems = items;
    state.groupIndex = 0;

    var optionsHtml =
      '<div class="kinujo-quick-add__option">' +
      '<span class="kinujo-quick-add__option-label">' + (label || '選択') + '</span>' +
      '<select class="kinujo-quick-add__option-select" data-group-select>' +
      items
        .map(function (item, index) {
          return '<option value="' + index + '">' + item.title + '</option>';
        })
        .join('') +
      '</select>' +
      '</div>';

    renderShell(items[0].image, items[0].title, optionsHtml);

    els.content.querySelector('[data-group-select]').addEventListener('change', function (event) {
      state.groupIndex = parseInt(event.target.value, 10) || 0;
      updateForSelection();
    });

    updateForSelection();
  }

  // Normalizes "single" (a real Shopify variant) and "group" (a stand-in
  // product from the merchant-configured group) into the same shape, so
  // the rest of the UI (price/image/availability/submit) doesn't need to
  // know which mode is active.
  function getCurrentSelection() {
    if (state.mode === 'group') {
      var item = state.groupItems[state.groupIndex];
      if (!item) return null;
      return {
        id: item.variantId,
        price: item.price,
        available: item.available,
        image: item.image,
        title: item.title
      };
    }

    var variant = state.variant;
    if (!variant) return null;
    return {
      id: variant.id,
      price: variant.price,
      available: variant.available,
      image: variant.featured_image ? variant.featured_image.src : null,
      title: null
    };
  }

  function updateForSelection() {
    var selection = getCurrentSelection();

    if (!selection) {
      els.price.textContent = '';
      els.submit.disabled = true;
      els.note.hidden = false;
      els.note.textContent = 'この組み合わせは購入できません。';
      return;
    }

    els.price.textContent = formatMoney(selection.price);

    if (selection.image && els.image) {
      els.image.src = selection.image;
    }
    if (selection.title && els.title) {
      els.title.textContent = selection.title;
    }

    if (!selection.available) {
      els.submit.disabled = true;
      els.note.hidden = false;
      els.note.textContent = '売り切れです。';
    } else {
      els.submit.disabled = false;
      els.note.hidden = true;
    }
  }

  function submit() {
    var selection = getCurrentSelection();
    if (!selection || !selection.available || els.submit.disabled) return;

    var quantity = parseInt(els.qty.value, 10) || 1;
    els.submit.disabled = true;
    var originalLabel = els.submit.textContent;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selection.id, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        // A cart-drawer app listening for /cart/add.js requests picks this
        // up and opens on its own — this just gives feedback in case it
        // doesn't, then closes this popup rather than navigating anywhere.
        els.submit.textContent = '追加しました';
        setTimeout(function () {
          els.submit.textContent = originalLabel;
          els.submit.disabled = false;
          close();
        }, 1200);
      })
      .catch(function () {
        els.submit.disabled = false;
      });
  }

  function openLoading() {
    if (!modalEl) buildModal();
    modalEl.hidden = false;
    lockScroll(true);
    els.content.innerHTML = '<p class="kinujo-quick-add__loading">読み込み中…</p>';
  }

  function open(handle) {
    if (!handle) return;
    openLoading();

    fetch('/products/' + handle + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        renderProduct(product);
      })
      .catch(function () {
        els.content.innerHTML = '<p class="kinujo-quick-add__loading">読み込みに失敗しました。</p>';
      });
  }

  function openGroup(handles, label) {
    if (!handles || !handles.length) return;
    openLoading();

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (response) {
          return response.json();
        });
      })
    )
      .then(function (products) {
        var items = products.map(function (product) {
          var variant = product.variants[0];
          return {
            handle: product.handle,
            title: product.title,
            image: variant.featured_image ? variant.featured_image.src : product.featured_image,
            price: variant.price,
            variantId: variant.id,
            available: variant.available
          };
        });
        renderGroup(items, label);
      })
      .catch(function () {
        els.content.innerHTML = '<p class="kinujo-quick-add__loading">読み込みに失敗しました。</p>';
      });
  }

  window.KinujoQuickAdd = { open: open, openGroup: openGroup, close: close };
})();
